import type { QueryKey } from '@tanstack/react-query';
import type { GetDependencyConfidenceResponse } from '../../../../shared/types/routes/binary';
import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';

const getRevisionDependencyConfidenceQueryKey = (
  revisionLocator: string,
): QueryKey => ['binary', revisionLocator, 'dependency-confidence'];

function getRevisionDependencyConfidence(revisionLocator: string) {
  return get<GetDependencyConfidenceResponse>(`/api/binary/${nuc(revisionLocator)}/dependency-confidence`);
}

/**
 * Helper hook for fetching the confidence of the dependencies of a user's revision.
 * @param revisionLocator - The revision locator of the user's revision.
 * @returns A query for the confidence of the revision's dependencies.
 */
export default function useRevisionDependencyConfidence(revisionLocator: string) {
  return useQuery<GetDependencyConfidenceResponse>({
    queryFn: () => getRevisionDependencyConfidence(revisionLocator),
    queryKey: getRevisionDependencyConfidenceQueryKey(revisionLocator),
  });
}
